import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { getTotalAge, readableDateFormat } from '../../utils/dateUtils'
import { startSxpProxy } from '../../utils/api'
import {
  AB_MEMBERHSIP_PROJECT_ID,
  ADMIN_PROJECT_ID,
  MEMBERSHIP_PROJECT_ID,
} from '../../utils/constants'
import { useAppSelector } from '../../app/hooks'
import { selectSelectedLocationId } from '../location/locationSlice'

import { makeName } from '../lms/utils'
import { odooPharmacyLink } from '../appointments/models'
import IconButton from '@mui/material/IconButton'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import { MembershipModel } from '../membership/models'
import { openUrlFromApi } from '../patients/utils'
import {
  ABMembershipIntent,
  Categories,
  enterText,
  errorPed,
  InvoiceLink,
  InvoiceList,
  noBenefits,
  NoMemberinFHIR,
  pedInfo,
  pedUpdated,
  Products,
} from './constants'
import { loadingText } from '../Radiology/Constants/constants'
import { tableText } from '../administration/constants'
import { ABMemebrship } from '../bedManagement/endpoints/EndPoints'

import AttachFileIcon from '@mui/icons-material/AttachFile'
import { Dialog, DialogContent, TextField, useTheme } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import EditIcon from '@mui/icons-material/Edit'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
import UploadAbDocs from './UploadAbDocs'
import { updatePed } from '../../services/MembershipDetailsService'
import { toast } from 'react-toastify'

type Benefit = {
  innerKey: string
  quantity: any
  allowedCount: any
  discountPrice: any
  category: any
  categoryId: any
}
type Invoice = {
  innerKey: string
  id: string
  uhid: string
  invoices: any
}
type Item = {
  allowedCount: number
  category: boolean
  categoryId: string
  discountPrice: string
  innerKey: string
  quantity: number
}

type ItemsObject = {
  [key: string]: Item[]
}
const styles = () => ({
  abMembershipDetail: {
    overflow: 'auto',
    width: '100%',
    tableLayout: 'auto',
  },
  policyHead: {
    minWidth: '150px',
  },
  nameHead: {
    minWidth: '200px',
  },
  editingIndex: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  displayIndex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
  editDisplayIndex: {
    cursor: 'pointer',
    minHeight: '20px',
    padding: '4px 8px',
    borderRadius: '4px',
  },
  editIcon: {
    padding: '4px',
  },
  pedInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
  },
})
const ABMembershipDetails = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const { id } = useParams()
  const navigate = useNavigate()
  const [membershipDetail, setMembershipDetail] = useState<MembershipModel[]>(
    []
  )
  const [benefits, setBenefits] = useState<ItemsObject>({})
  const [invoices, setInvoices] = useState<Invoice[]>([])
  const [member, setMember] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const location = useAppSelector(selectSelectedLocationId)
  const [isOpenDocsPage, setIsOpenDocsPage] = useState(false)
  const [selectedPatientId, setSelectedPatientId] = useState<string>('')
  const [selectedMuhId, setSelectedMuhId] = useState<string>('')
  const sortedKeys = Object.keys(benefits).sort()
  const sortedBenefits = {} as { [key: string]: any }
  sortedKeys?.forEach((key) => {
    const obj = benefits[key]
    obj.sort((a: any, b: any) =>
      a?.innerKey?.split(':')?.[1]?.toLowerCase() <
      b?.innerKey?.split(':')?.[1]?.toLowerCase()
        ? -1
        : 1
    )
    sortedBenefits[key] = obj
  })

  function isEmpty(obj: any) {
    for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
        return false
      }
    }

    return true
  }

  const fetchMembershipDetails = async (id: any, location: string) => {
    try {
      const data: any = await startSxpProxy(
        AB_MEMBERHSIP_PROJECT_ID,
        ABMembershipIntent?.abMembershipLine,
        {
          location,
          lineId: id,
        }
      )
      const fetchedMembershipDetail = data?.data
      setMembershipDetail(fetchedMembershipDetail)
      const uhid = fetchedMembershipDetail?.[0]?.partner?.ref
      const associatedUhid = fetchedMembershipDetail?.[0]?.partner_ids?.map(
        (e: { ref: any }) => e.ref
      )
      const memberIds: any[] = []
      memberIds?.push(fetchedMembershipDetail?.[0]?.date)
      if (fetchedMembershipDetail?.[0]?.membership_partner_ids) {
        for (const element of fetchedMembershipDetail) {
          const membershipPartnerIds = element?.membership_partner_ids || []
          for (const partnerId of membershipPartnerIds) {
            if (associatedUhid?.includes(partnerId?.partner_id.ref)) {
              memberIds?.push(partnerId?.activation_date)
            }
          }
        }
      }
      const memberUhidsArray = [uhid, ...associatedUhid]?.filter((ua) => !!ua)
      const membersOne = memberUhidsArray?.join(',')
      const state = { patientIdentifier: membersOne }
      const patientData: any = await startSxpProxy(
        MEMBERSHIP_PROJECT_ID,
        ABMembershipIntent?.getPatientById,
        state
      )
      if (patientData?.data?.data?.total > 0) {
        const memberDetails = patientData?.data?.data?.entry?.map(
          (e: { resource: any }) => e?.resource
        )
        const uhidObj = memberDetails.reduce(
          (acc: any, cur: { identifier: { value: any }[] }) => {
            const uhid = cur.identifier?.[2]?.value
            return { ...acc, [uhid]: cur }
          },
          {}
        )
        const memberDetailArray = memberUhidsArray?.map((d, i) => {
          const role = uhidObj[d]
          const relation =
            fetchedMembershipDetail?.[0]?.membership_partner_ids?.find(
              (partner: any) =>
                partner?.partner_id?.ref === role?.identifier?.[2]?.value
            )?.relation_with_primary_partner
          const data =
            fetchedMembershipDetail?.[0]?.membership_partner_ids?.find(
              (partner: any) =>
                partner?.partner_id?.ref === role?.identifier?.[2]?.value
            )

          return {
            names: makeName(role?.name),
            id: data?.id,
            name: fetchedMembershipDetail?.[0]?.name,
            memberId: data?.name,
            reference: data?.partner_id?.ref,
            primary: i === 0,
            age: getTotalAge(new Date(data?.partner_id?.dob)),
            gender: data?.partner_id?.gender,
            date: role?.identifier?.[3]?.period?.start
              ? readableDateFormat(
                  new Date(role?.identifier?.[3]?.period?.start)
                )
              : '-',
            memberDate: memberIds?.[i]
              ? readableDateFormat(new Date(memberIds[i]))
              : '-',
            uhid: role?.identifier?.[2]?.value || '-',
            isActive: data?.is_active,
            mobile: role?.telecom?.[0]?.value || '-',
            relation_with_primary_partner: relation || '',
            ped: data?.ped ?? '-',
          }
        })
        setMember(memberDetailArray)
      } else {
        setMember([])
      }
    } catch (error) {
      console?.error(error)
      setMember([])
    }
  }
  useEffect(() => {
    setLoading(true)
    fetchMembershipDetails(id, location)
  }, [id, location])

  const handleBack = () => {
    navigate(ABMemebrship)
  }
  const stringFunction = (d: string) => {
    const parts = d?.split(': ')
    if (parts?.length === 2) {
      return parts?.[1]?.trim()
    }
  }
  const fetchBenefitsAndInvoices = async (id: any, location: string) => {
    try {
      const itemsArray: any[] = []
      const data: any = await startSxpProxy(
        MEMBERSHIP_PROJECT_ID,
        ABMembershipIntent?.benefits,
        {
          location,
          id,
        }
      )
      const benefits = data?.data?.benefits || data?.benefits
      const invoices = data?.data?.invoices || data?.invoices
      for (const outerKey in benefits) {
        const innerObject = benefits[outerKey]
        for (const innerKey in innerObject) {
          const item = {
            innerKey: innerKey,
            quantity: innerObject[innerKey]?.quantity ?? '-',
            allowedCount: innerObject[innerKey]?.allowed_count ?? '-',
            discountPrice: innerObject[innerKey]?.disc_percent ?? '-',
            category: innerObject[innerKey]?.category,
            categoryId: innerObject[innerKey]?.categ_id,
          }
          itemsArray?.push(item)
        }
      }

      const itemsMap = itemsArray?.map((e) => {
        const item = []
        if (e?.category === false) {
          const cat = e?.categoryId
            ? e?.categoryId?.split('/')?.[0]?.trim()
            : e?.categoryId
          item?.push(cat)
        }
        return item
      })

      const filterItems = itemsMap?.flat()?.filter((item) => item?.length > 0)
      const unique = filterItems?.filter((value, index, self) => {
        return self?.indexOf(value) === index
      })
      const uniqueArray = unique?.sort()
      const reduceData = itemsArray?.reduce(
        (acc: Record<string, Benefit[]>, cur) => {
          if (cur.category) {
            const uniqueKey = cur?.innerKey
              ?.split(':')?.[1]
              ?.split('/')?.[0]
              ?.trim()
            if (!uniqueArray?.includes(uniqueKey)) {
              if (acc[Categories]) {
                acc[Categories]?.push(cur)
              } else {
                acc[Categories] = [cur]
              }
            }
          }
          let catId
          catId = cur?.categoryId
            ? cur?.categoryId?.split('/')?.[0]?.trim()
            : cur?.categoryId
          if (catId === undefined) {
            catId = cur?.innerKey?.split(':')?.[1]?.split('/')?.[0]?.trim()
          }

          if (uniqueArray.includes(catId)) {
            if (acc[catId]) {
              acc[catId]?.push(cur)
            } else {
              acc[catId] = [cur]
            }
          }

          return acc
        },
        {}
      )
      setBenefits(reduceData)
      if (invoices && Object?.keys(invoices)?.length > 0) {
        const invoicesArray: any[] = []
        for (const outKey in invoices) {
          const innerObject = invoices[outKey]
          for (const innerKey in innerObject) {
            const item = {
              innerKey: innerKey,
              id: innerObject?.[innerKey]?.id,
              uhid: innerObject?.[innerKey]?.uhid,
              invoices: innerObject?.[innerKey]?.invoices,
            }
            invoicesArray?.push(item)
          }
        }
        setInvoices(invoicesArray)
      } else {
        setInvoices([])
      }
    } catch (err) {
      console.error(err, 'error')
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    setLoading(true)
    fetchBenefitsAndInvoices(id, location)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const redirectPage = (id: any) => {
    openUrlFromApi(ADMIN_PROJECT_ID, odooPharmacyLink, {
      invoiceId: id,
      location: location,
    })
  }
  const handleDocClick = (patientId: string, muhid: string) => {
    setIsOpenDocsPage(true)
    setSelectedPatientId(patientId)
    setSelectedMuhId(muhid)
  }
  const handleCloseDialog = () => {
    setIsOpenDocsPage(false)
  }
  const [editingIndex, setEditingIndex] = useState(null)
  const [editValue, setEditValue] = useState('')

  const handleEditClick = (index: any, currentValue: string) => {
    setEditingIndex(index)
    setEditValue(currentValue || '')
  }

  const handleSave = async () => {
    const response = await updatePed({
      id: editingIndex !== null ? member?.[editingIndex]?.id : undefined,
      ped: editValue,
    })
    if (response?.success) {
      toast?.success(pedUpdated)
      fetchMembershipDetails(id, location)
    } else {
      toast?.error(errorPed)
    }
    setEditingIndex(null)
    setEditValue('')
  }
  const handleCancel = () => {
    setEditingIndex(null)
    setEditValue('')
  }
  return (
    <>
      <div className='typeOne'>
        <div className='dashboard-container'>
          <div>
            <IconButton onClick={handleBack} className='membership-icon-btn'>
              <KeyboardBackspaceIcon className='backspace-icon-membership-view' />
            </IconButton>
          </div>
          <div className='type'>
            <div className='typeCard'>
              <span className='typeCardOne'>
                {membershipDetail?.[0]?.membership_id?.[1].toLowerCase()}
              </span>
            </div>

            <div className='dateCard'>
              <span className='dateCardOne'>
                Created {membershipDetail?.[0]?.date_from}
              </span>
              <span className='dateCardOne'>
                Valid Till {membershipDetail?.[0]?.date_to}
              </span>
              <span className='wallet'>
                Wallet Balance:{membershipDetail?.[0]?.credits}.00
              </span>
            </div>
          </div>
        </div>
        <div>
          <table
            className={`data-table admin-table table-fixed ${classes?.abMembershipDetail}`}
          >
            <thead>
              <tr>
                <th className={`text-center ${classes?.policyHead}`}>
                  Policy Id
                </th>
                <th>Member Id</th>
                <th className='text-center'>Reference</th>
                <th className={`text-center ${classes?.nameHead}`}>Name</th>
                <th className='text-center'>Age</th>
                <th className='text-center'>Gender</th>
                <th className='text-center'>Relation with Primary Member</th>
                <th className='text-center'>PED</th>
                <th>Is Active</th>
                <th>Activation Date</th>
                <th className='text-center'>Documents</th>
              </tr>
            </thead>
            <tbody>
              {member?.length > 0 ? (
                member?.map((d, i) => (
                  <tr key={d?.id}>
                    <td>{d?.name}</td>
                    <td className='text-center'>{d?.memberId}</td>
                    <td className='text-center'>{d?.reference}</td>
                    <td>{d?.names}</td>
                    <td className='text-center'>{d?.age}</td>
                    <td className='text-center'>{d?.gender}</td>
                    <td className='text-center'>
                      {d?.relation_with_primary_partner}
                    </td>

                    <td className='text-center'>
                      {editingIndex === i ? (
                        <div className={classes?.editingIndex}>
                          <TextField
                            size='small'
                            value={editValue}
                            onChange={(e) => setEditValue(e.target.value)}
                            placeholder='Enter name'
                            autoFocus
                            className={classes?.policyHead}
                          />
                          <IconButton
                            size='small'
                            onClick={handleSave}
                            color='primary'
                          >
                            <CheckIcon fontSize='small' />
                          </IconButton>
                          <IconButton
                            size='small'
                            onClick={handleCancel}
                            color='error'
                          >
                            <CloseIcon fontSize='small' />
                          </IconButton>
                        </div>
                      ) : (
                        <div className={classes?.displayIndex}>
                          <span
                            className={classes?.editDisplayIndex}
                            onClick={() => handleEditClick(i, d?.ped)}
                          >
                            {d?.ped || enterText}
                          </span>
                          <IconButton
                            size='small'
                            onClick={() => handleEditClick(i, d?.ped)}
                            className={classes?.editIcon}
                          >
                            <EditIcon fontSize='small' />
                          </IconButton>
                        </div>
                      )}
                    </td>
                    <td className='text-center'>
                      {d?.isActive ? pedInfo?.true : pedInfo?.false}
                    </td>
                    <td className='text-center'>{d?.memberDate}</td>
                    <td className={classes?.pedInfo}>
                      <IconButton
                        onClick={() => handleDocClick('', d?.reference)}
                      >
                        <AttachFileIcon fontSize='small' />
                      </IconButton>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className='text-center'>
                    {member?.length === 0
                      ? `${NoMemberinFHIR}`
                      : `${loadingText}`}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div>
          <div className='search-table'>
            <p className='search-para'>Benefits:</p>
          </div>
          {!isEmpty(sortedBenefits) ? (
            Object?.keys(sortedBenefits)?.map((category) => (
              <div key={category} className='category'>
                <table className='data-table admin-table table-fixed'>
                  <thead>
                    <tr>
                      <th className='width-minor'>{tableText?.slNo}</th>
                      <th>
                        {category === `${Categories}`
                          ? `${Categories}`
                          : `${Products} (${category})`}
                      </th>
                      <th className='text-center'>{tableText?.Allowecount}</th>
                      <th className='text-center'>{tableText?.Quantity}</th>
                      <th className='text-center'>
                        {tableText?.DiscountPrice}(%)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedBenefits?.[category]?.map(
                      (item: any, index: any) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{stringFunction(item?.innerKey)}</td>
                          <td className='text-center'>{item?.allowedCount}</td>
                          <td className='text-center'>{item?.quantity}</td>
                          <td className='text-center'>{item?.discountPrice}</td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            ))
          ) : (
            <table className='data-table admin-table table-fixed'>
              <thead>
                <tr>
                  <th className='width-minor'>{tableText?.slNo}</th>
                  <th>{Products}</th>
                  <th className='text-center'>{tableText?.Allowecount}</th>
                  <th className='text-center'>{tableText?.Quantity}</th>
                  <th className='text-center'>{tableText?.DiscountPrice}(%)</th>
                </tr>
              </thead>
              <tbody>
                <td colSpan={5} className='text-center'>
                  {loading ? `${loadingText}` : `${noBenefits}`}
                </td>
              </tbody>
            </table>
          )}
        </div>
        {invoices.length > 0 && (
          <div>
            <div className='search-table'>
              <p className='search-para'>{InvoiceList}</p>
            </div>
            <table className='data-table admin-table table-fixed'>
              <thead>
                <tr>
                  <th className='width-minor'>{tableText?.slNo}</th>
                  <th className='text-center'>{tableText?.uhid}</th>
                  <th className='text-center'>{tableText?.name}</th>
                  <th className='text-center'>{InvoiceLink}</th>
                </tr>
              </thead>
              <tbody>
                {invoices?.length > 0 ? (
                  invoices?.map((d, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td className='text-center'>{d?.uhid}</td>
                      <td className='text-center'>{d?.innerKey}</td>
                      <td
                        className='text-center pointer'
                        onClick={() => redirectPage(d?.invoices?.[0]?.id)}
                      >
                        {d?.invoices?.[0]?.name}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className='text-center'>
                      {loadingText}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <Dialog open={isOpenDocsPage} onClose={handleCloseDialog} maxWidth='sm'>
        <IconButton onClick={handleCloseDialog} className='flex-end f12'>
          x
        </IconButton>
        <DialogContent className='margin2 padding20'>
          {' '}
          <UploadAbDocs
            patientId={selectedPatientId}
            muhid={selectedMuhId}
          />{' '}
        </DialogContent>
      </Dialog>
    </>
  )
}
export default ABMembershipDetails
